import axios from 'axios';

async function createLead(leadData) {
  const response = await axios
    .post('/marketing-lead', {
      companyName: leadData.name,
      adCategory: leadData.type,
      contact: leadData.contact,
      agreeToMarketing: leadData.isMarketingAgreed,
      x: leadData.x,
      y: leadData.y,
      ...(leadData.roadAddress && { address: leadData.roadAddress }),
      ...(leadData.type === 'STORE' && leadData.planMonths && { planMonths: leadData.planMonths }),
      ...(leadData.type === 'PRODUCT' && leadData.packagePrice && { packagePrice: leadData.packagePrice }),
      ...(leadData.type === 'PRODUCT' && { email: leadData.email }),
    })
    .then(res => {
      return res.data;
    });

  return response;
}

export { createLead };
